/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamLoungeHintResponse } from './oralExamLoungeHintResponse';
import type { OralExamLoungeResponseOrientationVideoUrl } from './oralExamLoungeResponseOrientationVideoUrl';
import type { OralExamLoungeResponseWaitingBedUrl } from './oralExamLoungeResponseWaitingBedUrl';

/**
 * Session-scoped waiting lounge payload for a booking.
 */
export interface OralExamLoungeResponse {
  hints?: OralExamLoungeHintResponse[];
  orientationVideoUrl?: OralExamLoungeResponseOrientationVideoUrl;
  waitingBedUrl?: OralExamLoungeResponseWaitingBedUrl;
}
